class ProductAmountModifier extends HTMLElement {
  constructor() {
    super();
    this.originalValue = null;
    this.QUANTITY_INCREASE_IS_ACTIVE = false;
  }

  connectedCallback() {
    // Query selectors should be done here to ensure elements are in the DOM
    this.mainQuantityInput = document.querySelector('#squareMeterInput');
    this.quantityInputs = document.querySelectorAll(".shopify-product-form .js-input-quantity");
    this.modifierInput = this.querySelector('.custom-toggle input');

    if (!this.mainQuantityInput || !this.modifierInput) {
      console.warn('Required elements not found.');
      return;
    }

    this.setupEventListeners();
    this.toggleVisibility(Number(this.mainQuantityInput.value) !== 0);
  }

  setupEventListeners() {
    this.quantityInputs.forEach( input => {
      input.addEventListener('input', ()=> {
        setTimeout(() => {
          this.toggleVisibility(Number(this.mainQuantityInput.value) !== 0);
        }, 300);

      if (this.QUANTITY_INCREASE_IS_ACTIVE) {
        this.modifierInput.checked = false;
        this.originalValue = null;
      }
      })
    })
    
    this.modifierInput.addEventListener('change', () => this.handleToggleChange());

      this.quantityInputs.forEach( input => {
        input.addEventListener('click', ()=> {
        if (this.modifierInput.checked) {
          this.modifierInput.checked = false;
          this.QUANTITY_INCREASE_IS_ACTIVE = false;
          this.originalValue = null;
        }
      })
    })

  }

  toggleVisibility(show) {
    this.classList.toggle('visible', show);
  }

  handleToggleChange() {
    if (this.modifierInput.checked) {
      this.modifyInputValue();
    } else {
      this.revertInputValue();
    }
  }

  modifyInputValue() {
    if (this.originalValue === null) {
      this.originalValue = Number(this.mainQuantityInput.value);
    }
    const additionalAmount = this.originalValue * 0.1;
    this.updateInputValue(this.originalValue + additionalAmount);
  }

  revertInputValue() {
    if (this.originalValue !== null) {
      this.updateInputValue(this.originalValue);
      this.originalValue = null;
      this.QUANTITY_INCREASE_IS_ACTIVE = false;
    }
  }

  updateInputValue(value) {
    this.mainQuantityInput.value = value.toFixed(1);
    this.mainQuantityInput.dispatchEvent(new Event('input')); // Ensure other listeners are triggered
  }
}

customElements.define('product-amount-modifier', ProductAmountModifier);
